import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestOptions, XHRBackend, HttpModule } from '@angular/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HttpService } from './http/http.service';
import { httpServiceFactory } from './factories';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './loader/loader.service';
import { SharedService } from './services/shared.service';
import { StoresPopupComponent } from './stores-popup/stores-popup.component';
import { HttpClientModule } from '@angular/common/http';
import { SharedComponent } from './shared.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FlashMessagesService } from './../shared/flash-messages/flash-messages.service';
@NgModule({
  declarations: [
    LoaderComponent,
    StoresPopupComponent,
    SharedComponent
  ],
  imports: [
    CommonModule,
    HttpModule,
    HttpClientModule,
    ModalModule.forRoot(),
    InfiniteScrollModule,
  ],
  exports: [
    LoaderComponent,
    StoresPopupComponent
  ],
  entryComponents: [
    StoresPopupComponent
  ],
  providers: [
    FlashMessagesService,
    LoaderService,
    SharedService,
    {
      provide: HttpService,
      useFactory: httpServiceFactory,
      deps: [XHRBackend, RequestOptions, LoaderService]
    }
  ],
  bootstrap: [SharedComponent]
})
export class SharedModule { }
